import { default as olFullScreen } from 'ol/control/FullScreen.js';
import {Control} from '../Control.js';

export class FullScreen extends Control {
    source = "plot";

    constructor( map, settings = {} ){
        settings["name"] = 'full_screen';
        if( settings['target'] == undefined ) settings['target'] = "full_screen";
        let source;
        if( settings['source'] != undefined ){ source = settings['source']; delete settings['source'];}
        super( map, settings );
        this.getState();
        if( source != undefined ) this.source = source;
        console.info( 'fs', this.source );

        this.control = new olFullScreen({
                "target": this.target,
                "source": this.source
                });
    }

}
